export default __webpack_public_path__ + "static/media/site-fonctionnel.3a50c25f.png";